<template>
    <div>
        <a-card type="inner" size="small">
            <a-skeleton :loading="preload" active>
                <a-form-model ref="ruleForm" :form="form" :layout="formLayout" :model="formData" :rules="rules">
                    <a-divider dashed orientation="left">Form Training Evaluastion</a-divider>

                    <a-form-model-item label="Nama" ref="name" prop="name">
                        <a-input v-model="formData.name" @blur=" () => { $refs.name.onFieldBlur() }"/>
                    </a-form-model-item>

                    <a-form-model-item>
                        <a-row type="flex" justify="center" align="top">
                            <a-col>
                                <a-space>
                                    <a-button
                                        type="primary"
                                        html-type="submit"
                                        :loading="processing"
                                        :disabled="processing"
                                        @click="handleSubmit"
                                        >Submit</a-button>
                                    <a-button
                                        @click="handleClose"
                                        :loading="processing"
                                        :disabled="processing"
                                        >Tutup</a-button>
                                </a-space>
                            </a-col>
                        </a-row>
                    </a-form-model-item>
                </a-form-model>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        trainingEvalId: {
            type: String,
            default: '0'
        },
        parentId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            form: this.$form.createForm(this),
            formLayout: 'horizontal',
            formData: {
                order: 0
            },
            processing: false,
            preload: false,
            fileList: [],
            rules: {
                name: [
                    { required: true, message: 'Please input Training name', trigger: 'blur' },
                ],
            },
        }
    },
    created() {
        if (this.editing) {
            this.preload = true
            this.getModuleItem()
        }
    },
    computed: {
        editing() {
            return this.trainingEvalId !== ""
        }
    },
    methods: {
        getModuleItem() {
            this.preload = true
            this.$http
                .get(this.routeUri('api.admin.training.evaluation.show', { training_evaluation: this.trainingEvalId }))
                .then(res => {
                    this.formData = res.data
                })
                .finally(() => (this.preload = false))
        },
        handleSubmit(e) {
            e.preventDefault(e)

            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.processing = true

                    let promise

                    let data = new FormData()

                    data.append("name", this.formData.name)

                    if(this.parentId){
                        data.append("parent_id", this.parentId)
                    }
                    if(!this.editing){
                        promise = this.$http.post(this.routeUri('api.admin.training.evaluation.store'), data)
                    }else{
                        promise = this.$http.post(this.routeUri('api.admin.training.evaluation.update', {training_evaluation: this.trainingEvalId}), data)
                    }

                    promise
                        .then(response => this.handleSuccessResponse(response.data))
                        .catch(error => this.handleResponseError(error.response.data))
                        .finally(() => (this.processing = false))
                }
            })
        },
        handleSuccessResponse(data) {
            let successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            })

            this.$emit("handleClose", true)
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    })
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                })
            }
        },
        handleClose() {
            this.$emit("handleClose", false)
        },
    },
}
</script>
